/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { StreemApiArtifactFromJSON, StreemApiArtifactToJSON, } from './';
export function StreemApiFulfillMeshResponseFromJSON(json) {
    return StreemApiFulfillMeshResponseFromJSONTyped(json, false);
}
export function StreemApiFulfillMeshResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'meshArtifact': !exists(json, 'mesh_artifact') ? undefined : StreemApiArtifactFromJSON(json['mesh_artifact']),
    };
}
export function StreemApiFulfillMeshResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'mesh_artifact': StreemApiArtifactToJSON(value.meshArtifact),
    };
}
//# sourceMappingURL=StreemApiFulfillMeshResponse.js.map